import React from "react";
import { Icon } from "@chakra-ui/react";

export const PlusIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="#1A1A1A" />
    </Icon>
  );
};
